const CAPTION = "imageCaption";
export {
  CAPTION
};
//# sourceMappingURL=data-hooks.js.map
